import {HttpClient} from '@angular/common/http';
import {PathService} from '../../login/services/path.service';
import {Observable} from 'rxjs';
import {CouponDtoModel} from '../models/coupon.dto.model';
import {Injectable} from '@angular/core';
import {PaginationArgs} from '../models/pagination.args';

@Injectable({
    providedIn: 'root'
})
export class CouponService {
    private baseUrl = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/coupon`;
    }

    public findAllCouponsByPage(codeToSearch: string, paginationArgs: PaginationArgs): Observable<CouponDtoModel[]> {
        return this.http.get<CouponDtoModel[]>(`${this.baseUrl}?page=${paginationArgs.pageNumber}&size=${paginationArgs.pageSize}&filterCode=${codeToSearch}`);
    }


    public updateCoupon(coupon: CouponDtoModel): Observable<CouponDtoModel> {
        return this.http.put<CouponDtoModel>(`${this.baseUrl}`, coupon);
    }

    public createCoupon(coupon: CouponDtoModel): Observable<CouponDtoModel> {
        return this.http.post<CouponDtoModel>(`${this.baseUrl}`, coupon);
    }

    public deleteCoupon(uuid: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${uuid}`);
    }

}
